module.exports = __webpack_public_path__ + "assets/img/0fffed49f89bb6de2245ea74d9fae4e1.svg";